import React, { useMemo, useState } from "react";
import { Box, Stack, useColorScheme } from "@mui/material";

interface IPoweredByProps {
  show: boolean;
}

export const PoweredByText: React.FC<IPoweredByProps> = ({ show }) => {
  const { mode } = useColorScheme();
  const isDarkMode = useMemo(
    () =>
      mode === "dark" ||
      (mode === "system" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches),
    [mode]
  );

  return show ? (
    <Box
      sx={{
        textAlign: "right"
      }}
      data-testid="powered-by-text-container"
    >
      <span
        style={{ color: isDarkMode ? "#9c9c9c" : "#666666", fontSize: "12px" }}
        data-testid="powered-by-label"
      >
        powered by{" "}
      </span>{" "}
      <span style={{ color: "#5e5f62", fontSize: "13px" }}>
        {" "}
        <a
          style={{
            fontWeight: "bold",
            color: isDarkMode ? "#53a8dc" : "#1565c0",
            textDecoration: "none"
          }}
          target="_blank"
          href="https://rooster.us"
          rel="noreferrer"
          aria-label="Rooster (opens in new tab)"
          data-testid="powered-by-rooster-link"
        >
          Rooster
          <span className="sr-only"> (opens in new tab)</span>
        </a>
      </span>
    </Box>
  ) : (
    <></>
  );
};

export const PoweredByBadge: React.FC<
  IPoweredByProps & { translucent?: boolean; hideOnHover?: boolean }
> = ({ show, translucent = false, hideOnHover = false }) => {
  const { mode } = useColorScheme();
  const isDarkMode = useMemo(
    () =>
      mode === "dark" ||
      (mode === "system" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches),
    [mode]
  );

  return show ? (
    <Stack
      component="aside"
      role="complementary"
      aria-label="Branding"
      sx={{
        position: "fixed",
        bottom: "16px",
        right: "16px",
        border: isDarkMode ? "1px solid #565656" : "1px solid #e0e0e0",
        ...(!translucent && {
          background: isDarkMode
            ? "rgba(31, 31, 31, 0.9)"
            : "rgba(249, 249, 249, 0.9)"
        }),
        borderRadius: "5px",
        paddingX: "6px",
        paddingY: "2px",
        zIndex: 1000,
        ...(translucent && {
          backdropFilter: "blur(10px)"
        }),
        opacity: 1,
        transition: "opacity 0.3s ease",
        ...(hideOnHover && {
          "&:hover": {
            opacity: 0
          }
        })
      }}
      data-testid="powered-by-badge"
    >
      <PoweredByText show />
    </Stack>
  ) : (
    <></>
  );
};
